<template>
  <UApp>
    <UHeader mode="slideover">
      <template #title>
        <div class="flex items-center flex-nowrap gap-4">
          <NuxtImg class="h-16 w-auto" src="/logo.png" />
        </div>
      </template>

      <UNavigationMenu :items="items" class="hidden lg:flex" />
      <template #right>
        <UButton variant="outline" to="tel:+420773146244"
          >+420 773 146 244</UButton
        >
      </template>

      <template #body>
        <UNavigationMenu
          :items="items"
          orientation="vertical"
          class="-mx-2.5"
        />
      </template>
    </UHeader>

    <UMain>
      <slot />
    </UMain>

    <UFooter :ui="{ left: 'flex-col' }">
      <template #left>
        <p class="text-muted text-sm">
          Copyright © {{ new Date().getFullYear() }} Kevin Janak
        </p>
        <p class="text-muted text-sm">IČO: 21942587</p>
      </template>
      <UNavigationMenu :items="footerItems" variant="link" />
      <template #right>
        <p class="text-muted text-sm">
          Powered by: <a href="https://vytisknem.to">vytisknem.to s.r.o.</a>
        </p>
      </template>
    </UFooter>
  </UApp>
</template>

<script lang="ts" setup>
import type { NavigationMenuItem } from "@nuxt/ui";

const route = useRoute();

useSeoMeta({
  description:
    "Instalatéři, kteří rozumějí významu okamžiku. Řešíme všechny problémy s vodou, topením a kanalizací. Rychle, kvalitně a dřív, než vám děti zfousatěj.",
  ogTitle: "Janak instalatérství",
  ogDescription:
    "Instalatéři, kteří rozumějí významu okamžiku. Řešíme všechny problémy s vodou, topením a kanalizací. Rychle, kvalitně a dřív, než vám děti zfousatěj.",
  ogImage: "/hajzl.png",
  ogUrl: "https://www.janak-instalaterstvi.cz",
  twitterTitle: "Janak instalatérství",
  twitterDescription:
    "Instalatéři, kteří rozumějí významu okamžiku. Řešíme všechny problémy s vodou, topením a kanalizací. Rychle, kvalitně a dřív, než vám děti zfousatěj.",
  twitterImage: "/hajzl.png",
  twitterCard: "summary",
});
useHead({
  htmlAttrs: {
    lang: "cs-CZ",
  },
  link: [
    {
      rel: "apple-touch-icon",
      type: "image/x-icon",
      sizes: "180x180",
      href: "/apple-touch-icon.png",
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon-32x32.png",
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon-16x16.png",
    },
    {
      rel: "icon",
      type: "image/x-icon",
      sizes: "32x32",
      href: "/favicon.ico",
    },
    {
      rel: "manifest",
      href: "/site.webmanifest",
    },
  ],
});
const items = computed<NavigationMenuItem[]>(() => [
  {
    label: "Domů",
    to: "/",
    active: false,
    class: "hover:text-primary",
  },
  {
    label: "Služby",
    to: "/#sluzby",
    active: false,
    class: "hover:text-primary",
  },
  {
    label: "O nás",
    to: "/#o-nas",
    active: false,
    class: "hover:text-primary",
  },
  // {
  //   label: "Reference",
  //   to: "/#reference",
  //   active: false,
  //   class: "hover:text-primary",
  // },
  {
    label: "Kontakt",
    to: "/#kontakt",
    active: false,
    class: "hover:text-primary",
  },
  {
    label: "Fotogalerie",
    to: "/fotogalerie",
    active: route.path.startsWith("/fotogalerie"),
    class: "hover:text-primary",
  },
]);

const footerItems: NavigationMenuItem[] = [
  {
    icon: "i-simple-icons-facebook",
    to: "https://www.facebook.com/profile.php?id=61565203664697",
    target: "_blank",
  },
  {
    icon: "i-simple-icons-instagram",
    to: "https://www.instagram.com/instalater_janak/",
    target: "_blank",
  },
];
</script>

<style></style>
